import isEqual from 'lodash/isEqual';
import { ProfileSettings } from './types';

/** Keep local-only keys until they are persisted to the user profile. */
export function mergeLocalPendingProfileSettings(
  backendSettings: ProfileSettings,
  localSettings: ProfileSettings,
): ProfileSettings {
  const mergedSettings = { ...backendSettings };

  for (const [settingName, settingValue] of Object.entries(localSettings)) {
    if (!(settingName in backendSettings)) {
      (mergedSettings as Record<string, unknown>)[settingName] = settingValue;
    }
  }

  return mergedSettings;
}

export function hasUnpersistedProfileSettings(
  backendSettings: ProfileSettings,
  localSettings: ProfileSettings,
) {
  return !isEqual(
    mergeLocalPendingProfileSettings(backendSettings, localSettings),
    backendSettings,
  );
}
